
import { SvgIcon, SvgIconProps } from "@mui/material";
    
export const MinusIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><g clip-path="url(#a)"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16 12H8"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h24v24H0z"/></clipPath></defs></svg>
  </SvgIcon>
);
